import type { ReactNode } from 'react'
import { ArrowLeft } from 'lucide-react'
import { useSmartBack } from '@/lib/hooks/useSmartBack'

interface Props {
  title: string
  description?: string
  icon?: ReactNode
  showBack?: boolean
}

export default function SubpageHero({ title, description, icon, showBack = true }: Props) {
  const smartBack = useSmartBack()

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#1e3a8a] via-[#2563eb] to-[#4338ca]">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '20px 20px' }} />
      <div className="relative max-w-4xl mx-auto px-6 py-12">
        {showBack && (
          <button
            onClick={smartBack}
            className="flex items-center gap-1.5 text-sm text-white/60 hover:text-white/90 transition-colors mb-4"
          >
            <ArrowLeft size={16} /> 뒤로가기
          </button>
        )}
        <div className="flex items-center gap-3">
          {icon && (
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 backdrop-blur-sm">
              {icon}
            </div>
          )}
          <div>
            <h1 className="text-2xl font-bold text-white">{title}</h1>
            {description && <p className="mt-1 text-sm text-white/60">{description}</p>}
          </div>
        </div>
      </div>
    </div>
  )
}
